import * as yup from "yup";
import { urlValidation } from "../../CloudStorage/CommonFunction";
import { descriptionvalidation, titlevalidation } from "../Common/commonvalidation";

export const aboutexpert1 = () =>
  yup.object({
    iam: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    // national_id: yup.string().trim().required('This Field is Required').test('not-only-spaces', 'Please enter a valid value', value => value.trim() !== ''),
    designation: titlevalidation,
    about: descriptionvalidation,
  });

export const aboutexpert2 = () =>
  yup.object({
    iam: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    company_name: titlevalidation,
    // about_file: yup
    //   .string()
    //   .trim()
    //   .required("This Field is Required")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value.trim() !== ""
    //   ),
    // about_files: yup
    // .array()
    // .of(
    //   yup.object().shape({
    //     file: yup.string().url().required("File URL is required"),
    //   })
    // )
    // .test(
    //   "at-least-one-file",
    //   "At least one file is required",
    //   (value) => Array.isArray(value) && value.length > 0
    // ),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    country_id: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    website_link: yup
      .string()
      .required("URL is required")
      .test("valid-url", "Enter a valid URL", (value) => urlValidation(value)),
    // wathq_verification: yup.string().trim().required('This Field is Required').test('not-only-spaces', 'Please enter a valid value', value => value.trim() !== ''),
    // industries: yup
    //   .string()
    //   .required("This Field is Required")
    //   .min(1, "Please select at least 1 industries"),
    about: descriptionvalidation,
  });

export const cvpreferences = () =>
  yup.object({
    cv: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    full_time_job: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    category_id: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    current_job_title: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    work_location: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    part_time: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    price_per_hour: yup
      .number()
      .required("This Field is Required")
      .typeError("Please enter a valid number"),
    price_per_month: yup
      .number()
      .required("This Field is Required")
      .typeError("Please enter a valid number"),
    working_country: yup
      .string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
  });
export const cvpreferences1 = yup.object().shape({
  part_time: yup.string().required("Part time job preference is required"),
  price_per_hour: yup
    .number()
    .typeError("Price per hour must be a number")
    .required("Price per hour is required"),
  price_per_month: yup
    .number()
    .typeError("Price per month must be a number")
    .required("Price per month is required"),
  working_country: yup
    .string()
    .required("Preferred working country is required"),
  work_location: yup.string().required("Preferred work location is required"),
});
